import { SET_DRUG_LIST } from '../constants/Drug';

export const setDrugList = (drugList) => {
  return {
    type: SET_DRUG_LIST,
    drugList
  };
};
